export default "__VITE_ASSET__Dn_SFLY0__"